import { Component, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { GlobalService } from '../global.service';
import { ModalController, LoadingController } from '@ionic/angular';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.page.html',
  styleUrls: ['./roles.page.scss'],
})
export class RolesPage implements OnInit {

    ismodal = false;
    character = GlobalService.CHARACTER;
    roles = GlobalService.Roles;
    constructor(private router: Router, private modalController: ModalController) { }

  ngOnInit() {
  }
    close() {
        this.modalController.dismiss();
    }

    select(item) {
        this.character.role = item.name;
        if (this.ismodal) {
            this.close();
        }
    }

}
